import { remoteLog } from "./remote-log.js";

const contexts = {};

export const log = (contextName) => {
  if (contexts[contextName]) {
    return contexts[contextName];
  }

  return new Proxy(
    {},
    {
      get: (target, property) => {
        return (...args) => {
          args.unshift(`[${contextName}]`);

          window.console[property](...args);

          // this is hard-coded for now until I decide on a better approach
          // see remote-logs.js
          if (property === "error") {
            remoteLog({ contextName, data: args, logLevel: property });
          }
        };
      },
    }
  );
};
